var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 25H5.2C4.4 25 3.7 24.6 3.3 23.9C2.9 23.2 3 22.4 3.4 21.7L4.5 20C6.3 17.3 7.2 14.2 7.2 11C7.2 7.3 9.6 3.9 13.1 2.7C13.7 1.6 14.8 1 16 1C17.2 1 18.3 1.6 18.9 2.7C22.4 3.9 24.8 7.3 24.8 11C24.8 14.2 25.7 17.3 27.5 20L28.6 21.7C29 22.4 29.1 23.2 28.7 23.9C28.4 24.6 27.6 25 26.8 25Z",
    fill: "#0E0D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 27C11.6 29.3 13.6 31 16 31C18.4 31 20.4 29.3 20.9 27H11.1Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.d06c35ec998eb482685a6e318e13d1c5.svg";
export { ForwardRef as ReactComponent };